module.exports = __webpack_public_path__ + "img/mobile-job-icon.7caf5117.svg";